import type { ReactNode } from 'react'

export function KPIWidget({ label, value, detail, icon, tone = 'blue' }: { label: string; value: string | number; detail?: string; icon?: ReactNode; tone?: 'blue' | 'cyan' | 'orange' | 'navy' | 'green' }) {
  return <article className={`kpi-card kpi-card--${tone}`}><div className="kpi-card__top"><span>{label}</span>{icon && <span className="kpi-card__icon">{icon}</span>}</div><strong>{value}</strong>{detail && <small>{detail}</small>}</article>
}
